'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputGroupItem = InputGroupItem;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _sharedStyles = require('../shared-styles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var InputGroupWrapper = (0, _glamorous2.default)('div')({
  display: 'flex',
  flexGrow: 1,
  '> :not(:last-child)': {
    borderRight: 0
  },
  '> :first-child': {
    borderBottomRightRadius: 0,
    borderTopRightRadius: 0
  },
  '> :last-child': {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0
  },
  '> :not(:first-child):not(:last-child)': {
    borderRadius: 0
  }
});
var itemStyles = function itemStyles(_ref) {
  var theme = _ref.theme,
    smallText = _ref.smallText;
  var smallStyles = {};
  if (smallText) {
    smallStyles = {
      minWidth: '60px',
      fontSize: '12px',
      lineHeight: '33px',
      textAlign: 'center',
      textTransform: 'uppercase'
    };
  }
  return Object.assign({
    backgroundColor: theme.colorOffWhite
  }, (0, _sharedStyles.inputBorder)(theme), {
    lineHeight: '3rem',
    margin: 0,
    padding: '.6rem 1rem'
  }, smallStyles);
};
var Item = (0, _glamorous2.default)('div')(itemStyles);
InputGroupItem.propTypes = {
  children: _propTypes.node,
  text: _propTypes.string,
  onClick: _propTypes.func,
  smallText: _propTypes.bool
};
InputGroupItem.defaultProps = {
  children: null,
  smallText: false,
  text: undefined,
  onClick: undefined
};
function InputGroupItem(props) {
  var onClickProps = {
    onClick: props.onClick,
    tabIndex: '0',
    role: 'button'
  };
  var children = props.children,
    text = props.text,
    smallText = props.smallText,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, ['children', 'text', 'smallText', 'onClick']);
  return _react2.default.createElement(Item, Object.assign({
    smallText: smallText
  }, typeof onClick !== 'undefined' ? onClickProps : {}, rest), text || children);
}
exports.default = InputGroupWrapper;